import { createUseStyles } from 'react-jss'

import { colors, desktop } from '../../theme'


export default createUseStyles({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 5,
    paddingTop: '1rem',
    paddingBottom: '1rem',
    background: colors.pureBlack,
    ...desktop({
      paddingTop: '1.6rem',
      paddingBottom: '1.6rem',
    }),
  },
  wrapper: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingLeft: '1.6rem',
    paddingRight: '1.6rem',
    '& > *:not(.is-notstaggered)': {
      opacity: 0, // to prevent FOUC
    },
  },
  logoMainWrapper: {
    display: 'flex',
  },
  logoMainLink: {
    display: 'flex',
    color: 'inherit',
  },
  logoMain: {
    display: 'flex',
    width: '11rem',
    height: '1.4rem',
    background: colors.pureBlack,
    outline: `0.4rem solid ${colors.pureBlack}`,
    '& svg': {
      width: '100%',
      height: 'auto',
    },
    ...desktop({
      width: '13rem',
      height: '1.5rem',
    }),
  },
  logoFallWrapper: {
    display: 'none',
    '& svg': {
      width: '100%',
      height: 'auto',
    },
    ...desktop({
      position: 'absolute',
      left: 'calc(61% + 6.6rem - 0.5rem)', // same as the padding in onboarding - some black space inside logo
      top: '50%',
      display: 'flex',
      transform: 'translateY(-50%)',
    }),
  },
  logoFall: {
    display: 'none',
    ...desktop({
      display: 'flex',
      width: '4rem',
      height: '1.2rem',
      background: colors.pureBlack,
      outline: `0.4rem solid ${colors.pureBlack}`,
    }),
  },
  navigation: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginLeft: 'auto',
    '& > *': {
      margin: 0,
    },
    '& > * + *': {
      marginLeft: '1.2rem',
    },
  },
})
